import { render, staticRenderFns } from "./SceneItem.vue?vue&type=template&id=37c9a992&scoped=true&"
import script from "./SceneItem.vue?vue&type=script&lang=js&"
export * from "./SceneItem.vue?vue&type=script&lang=js&"
import style0 from "./SceneItem.vue?vue&type=style&index=0&id=37c9a992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c9a992",
  null
  
)

export default component.exports